'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _ChartWrapper = require('components/ChartWrapper/ChartWrapper');

var _ChartWrapper2 = _interopRequireDefault(_ChartWrapper);

var _statistics = require('helpers/statistics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var GeographyChart = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(GeographyChart, _PureComponent);

  function GeographyChart() {
    (0, _classCallCheck3.default)(this, GeographyChart);
    return (0, _possibleConstructorReturn3.default)(this, (GeographyChart.__proto__ || (0, _getPrototypeOf2.default)(GeographyChart)).apply(this, arguments));
  }

  (0, _createClass3.default)(GeographyChart, [{
    key: 'getChartData',
    value: function getChartData() {
      var data = this.props.data.data;
      var t = this.context.t;
      var statName = this.props.statName;


      return [[t('Country'), statName || t('Plays')]].concat((0, _toConsumableArray3.default)(data), [
      // should be at least one country with non zero value to fix google charts bug
      // with empty tooltips and blue coloring for all countries
      ['notExistingCountry', 1]]);
    }
  }, {
    key: 'getChartProps',
    value: function getChartProps() {
      var _props = this.props,
          id = _props.id,
          displayMode = _props.displayMode;

      var data = this.getChartData();

      return {
        graphId: id,
        chartType: 'GeoChart',
        data: data,
        options: {
          displayMode: displayMode,
          sizeAxis: {
            minValue: 2,
            maxSize: 6,
            minSize: 2
          }
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var loading = this.props.loading;

      var chartProps = this.getChartProps();

      return _react2.default.createElement(_ChartWrapper2.default, {
        chartProps: chartProps,
        height: 460,
        loading: loading
      });
    }
  }]);
  return GeographyChart;
}(_react.PureComponent), _class2.propTypes = {
  data: _propTypes2.default.object,
  displayMode: _propTypes2.default.oneOf(['auto', 'regions', 'markers', 'text']),
  id: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  statName: _propTypes2.default.string
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  data: _statistics.defaultChartData,
  displayMode: 'regions',
  id: 'geographyChart'
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'getChartData', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getChartData'), _class.prototype)), _class);
exports.default = GeographyChart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/GeographyChart/GeographyChart.js
// module id = 2112
// module chunks = 1